import {displayTimeStamp as displayTimeStampImpl} from '@/timestamp';
import {translate as getTranslation} from '@/translate';

export function useLocalisation() {
  const userSettingsStore = useUserSettingsStore();
  const language = computed(() => userSettingsStore.userSettings.language);
  const translate = (text: string) => getTranslation(language.value, text);
  const displayTimeStamp = (date: Date) => displayTimeStampImpl(date, language.value);
  return {language, translate, displayTimeStamp};
}
